export type GoogleAnalyticsEvents =
  | "form_tdc"
  | "form_ca"
  | "form_py"
  | "form_cs"
  | "form_cs_basica"
  | "form_cs_plus"
  | "form";
export const GA_EVENTS = {
  FLOW: {
    OPEN_ACCOUNT: "Paso1_AbriTucuenta",
    LANDING: "Landing",
    LANDING_TDC: "Landing_TDC",
    LANDING_CA: "Landing_CA",
    LANDING_PY: "Landing_PY",
    LANDING_CS: "Landing_CS",
    LANDING_CS_PLUS: "Landing_CS_PLUS",
    LANDING_CS_BASIC: "Landing_CS_BASIC",
    PRODUCT_SELECT: "Paso2_EleccionDeProducto",
    PRODUCT_SELECT_TDC: "Paso2_EleccionDeProducto_TDC",
    PRODUCT_SELECT_CA: "Paso2_EleccionDeProducto_CA",
    PRODUCT_SELECT_CS_PLUS: "Paso2_EleccionDeProducto_CS_PLUS",
    PRODUCT_SELECT_CS_BASIC: "Paso2_EleccionDeProducto_CS_BASIC",
    PRODUCT_SELECT_DA_COLEGIO: "Paso2_EleccionDeProducto_DA_COLEGIOS",
    ONBOARDING_DUPLICATED: "OnboardingDuplicated",
    IDENTIFICATION_SELECTION: "Paso3_EleccionDeTipoDeCedula",
    GO_SUCURSAL: "Paso4.1_DirigirseASucursal",
    IDENTIFICATION_WITH_CHIP: "Paso5.1_CedulaConChip",
    IDENTIFICATION_WITHOUT_CHIP: "Paso5.2_CedulaSinChip",
    IDENTIFICATION_VERIFICATION: "Paso6.1.1_VerificacionIdentidad",
    UPDATE_PROSPECT_WITH_CHIP: "Paso7.1_ConfirmacionDatosPrincipalesCIChip",
    UPDATE_PROSPECT_WITHOUT_CHIP:
      "Paso7.2_ConfirmacionDatosPrincipalesCISinChip",
    UPDATE_PROSPECT_MAIN_INFO: "Paso7.1.2_ConfirmacionDatosPrincipales",
    UPDATE_PROSPECT_MAIN_INFO_CS_URUGUAY:
      "Paso7.1.2_ConfirmacionDatosPrincipales_CS_URUGUAY",
    UPDATE_PROSPECT_MAIN_INFO_CS_EXTRANJERO:
      "Paso7.1.2_ConfirmacionDatosPrincipales_CS_EXTRANJERO",
    EMAIL_VALIDATED: "Paso7.3_ValidacionEmail",
    PHONE_VALIDATED: "Paso7.4_ValidacionCelular",
    ADDRESS_VERIFICATION: "Paso16_VerificacionDeDireccion",
    EMAIL_OTP_MAX_ATTEMPTS: "Paso7.3_MaximoIntentosValidacionOTPEmail",
    PHONE_OTP_MAX_ATTEMPTS: "Paso7.4_MaximoIntentosValidacionOTPCelular",
    EMAIL_OTP_TOO_MANY_REQUESTS:
      "Paso7.3_UsuarioBloqueadoPorDemasiadasSolicitudesOTPEmail",
    PHONE_OTP_TOO_MANY_REQUESTS:
      "Paso7.4_UsuarioBloqueadoPorDemasiadasSolicitudesOTPCelular",
    KYC_PYME: "Paso8_CuentaPyme",
    VALIDATION_RUT: "Paso7.1.1_ValidacionRutPyme",
    ACTIVITY_PYME: "Paso7.1.2_ConfirmacionDatosActividadPYME",
    UPDATE_KYC_PERSONAL_INFO: "Paso8.3_ConfirmacionDatosPersonales",
    YOUNG_ACCOUNT_TYPE: "Paso8_CuentaJoven",
    PLUS_ACCOUNT_TYPE: "Paso10_CuentaPlus",
    COLLEGUE_PLUS_ACCOUNT_TYPE: "Paso10_CuentaSelect_Colegios",
    AFFINITY_PROGRAM: "Paso11_ProgramadeAfinidad",
    SEGMENT_SELECTION: "Paso12_SeleccionDeSegmento",
    BRAND_SELECTION: "Paso12_SeleccionDeSello",
    INSURANCE_SELECTION: "Paso12_ContrataSeguro",
    BIOMETRIC_START: "Paso6_InicioBiometria",
    LIFE_PROOF_SELFIE: "Paso15_SelfiePruebadeVida",
    SELFIE_VALIDATION_FAILED: "Paso6_SelfieNoValidada",
    FINAL_ONBOARDING: "Paso17_FinalOnboarding",
    VISA_PLATINUM_SELECTION: "Paso12.1_SeleccionVISAPlatinum",
    IDENTIFICATION_WITH_CHIP_DELIVERY: "Paso13_CI_ConChip_EnvioProducto",
    IDENTIFICATION_WITHOUT_CHIP_DELIVERY: "Paso13_CI_SinChip_EnvioADomicilio",
    CERTIFICATE_OF_DGI: "DGI_ImagenEnviada",
    CERTIFICATE_OF_BPS: "BPS_ImagenEnviada",
    CERTIFICATE_OF_RUT: "RUT_ImagenEnviada",
    EMPLOYER_DATA_SENT: "Datos_Empleador_Enviados",
    REFERENTS_PYMES: "Pyme_Referentes",
  },
  ERRORS: {
    REQUEST_CREATE_ONBOARDING_LANDING:
      "Paso1_Landing_ErrorRequestCrearOnboarding",
    REQUEST_TOKEN: "Paso1_Landing_ErrorRequestToken",
    REQUEST_ENROLLMENT_REQUEST_CREATE_ONBOARDING_LANDING:
      "Paso1_Landing_EnrolamientoParamsErrors",
    ENROLLMENT_USER_BLOCKED: "Paso1_Landing_Enrolamiento_UserBlocked",
    REQUEST_ENROLLMENT_REQUEST_CREATE_ONBOARDING_SELFIE:
      "Paso6_Selfie_EnrolamientoParamsErrors",
    SELFIE_ENROLLMENT_BLOCKED: "Paso6_Selfie_Enrolamiento_Bloqueado",
    REQUEST_COLLEGE_STATUS: "Paso1_Landing_CollegePackageStatusError",
    REQUEST_CREATE_ONBOARDING: "Paso2_ErrorRequestCrearOnboarding",
    ONBOARDING_APPIAN_ERROR: "OnboardingAppianError",
    REQUEST_PROSPECTS: "Paso2_ErrorRequestCrearProspects",
    REQUEST_IDENTIFICATION_VERIFICATION: "Paso6.1.2_ErrordeLectura",
    REQUEST_UPDATE_PROSPECT_WITHOUT_CHIP:
      "Paso7.1_ErrorRequestActualizarProspectoSinChip",
    REQUEST_UPDATE_PROSPECT_WITH_CHIP:
      "Paso7.1_ErrorRequestActualizarProspectoConChip",
    REQUEST_ADDRESS_VERIFICATION: "Paso8.1_ErrorConfirmacionResidencia",
    PYMES_DOCUMENTS: "Paso8.1_ErrorDocumentosPymes",
    WRONG_PERSONAL_INFO_COMBINATION: "Paso8.3.1_ErrorCombinacionInvalida",
    ACCOUNT_FLOW_NOT_CONFIRMED: "Paso8.2_NoConfirmaFlujoDeCuenta",
    QUERY_RETURN_EVENT: "EventodeRegresodeConsulta",
    ACTIVITY_PYME_FORBIDDEN_RESTRICTED:
      "Paso7.1.2_ActividadPYME_ProhibidaRestringida",
    FAILED_RUT_VALIDATION: "Paso7.1.1_Validacion_Rut_Fallida",
    INVALID_SALARY_ACCOUNT: "Select.Salary.Account_Invalid_AccountType",
    SELPHI_UNEXPECTED_ERROR: "Unexpected Error",
    SELPHI_ENGINE_ERROR: "Engine Error",
    OCR_ERROR: "CI OCR Error",
    COLLEGE_DEBITS_ERROR: "College Debits Error",
    GO_SUCURSAL: "Error_IrASucursal",
    EMAIL_OTP_GENERATE_SEND_UNAUTHORIZED:
      "Paso7.3_ErrorRequestGenerateSendOTPEmail",
    PHONE_OTP_GENERATE_SEND_UNAUTHORIZED:
      "Paso7.4_ErrorRequestGenerateSendOTPCelular",
  },
};

const { ERRORS, FLOW } = GA_EVENTS;

export type GoogleAnalyticsCategories =
  // On Landing load
  | "Paso1_AbriTucuenta"
  | "Landing"
  | "Landing_TDC"
  | "Landing_CA"
  | "Landing_CS"
  | "Landing_CS_PLUS"
  | "Landing_CS_BASIC"
  // On product selected
  | "Paso2_EleccionDeProducto_TDC"
  | "Paso2_EleccionDeProducto_CA"
  | "Paso2_EleccionDeProducto_CS_PLUS"
  | "Paso2_EleccionDeProducto_CS_BASIC"
  | "Paso2_EleccionDeProducto_DA_COLEGIOS"
  | "Paso3_EleccionDeTipoDeCedula"
  | "Paso4.1_DirigirseASucursal"
  | "Paso5.1_CedulaConChip"
  | "Paso5.2_CedulaSinChip"
  | "Paso6.1.1_VerificacionIdentidad"
  | "Paso6.1.2_ErrordeLectura"
  | "Paso6_InicioBiometria"
  | "Paso6_SelfieNoValidada"
  | "Paso7.1_ConfirmacionDatosPrincipalesCIChip"
  | "Paso7.1.2_ConfirmacionDatosPrincipales"
  | "Paso7.1.2_ConfirmacionDatosPrincipales_CS_URUGUAY"
  | "Paso7.1.2_ConfirmacionDatosPrincipales_CS_EXTRANJERO"
  | "Paso7.2_ConfirmacionDatosPrincipalesCISinChip"
  | "Paso7.2.1_ConfirmacionDatosPrincipales"
  | "Paso8.1_ErrorConfirmacionResidencia"
  | "Paso8.1_ErrorDocumentosPymes"
  | "Paso8.2_NoConfirmaFlujoDeCuenta"
  | "Paso8.3_ConfirmacionDatosPersonales"
  | "Paso8.3.1_ErrorCombinacionInvalida"
  | "Paso8_CuentaJoven"
  | "Paso10_CuentaPlus"
  | "Paso11_ProgramadeAfinidad"
  | "Paso12_SeleccionDeSegmento"
  | "Paso12_SeleccionDeSello"
  | "Paso12_ContrataSeguro"
  | "Paso12.1_SeleccionVISAPlatinum"
  | "Paso13_CI_ConChip_EnvioProducto"
  | "Paso13_CI_SinChip_EnvioADomicilio"
  | "Paso15_SelfiePruebadeVida"
  | "Paso16_VerificacionDeDireccion"
  | "Paso17_FinalOnboarding"
  | "EventodeRegresodeConsulta"
  | typeof FLOW.KYC_PYME
  | typeof FLOW.ACTIVITY_PYME
  | typeof FLOW.EMAIL_VALIDATED
  | typeof FLOW.PHONE_VALIDATED
  | typeof FLOW.EMAIL_OTP_MAX_ATTEMPTS
  | typeof FLOW.PHONE_OTP_MAX_ATTEMPTS
  | typeof FLOW.EMAIL_OTP_TOO_MANY_REQUESTS
  | typeof FLOW.PHONE_OTP_TOO_MANY_REQUESTS
  | typeof FLOW.ONBOARDING_DUPLICATED
  | typeof ERRORS.ONBOARDING_APPIAN_ERROR
  | typeof ERRORS.REQUEST_TOKEN
  | typeof ERRORS.REQUEST_ENROLLMENT_REQUEST_CREATE_ONBOARDING_LANDING
  | typeof ERRORS.ENROLLMENT_USER_BLOCKED
  | typeof ERRORS.REQUEST_ENROLLMENT_REQUEST_CREATE_ONBOARDING_SELFIE
  | typeof ERRORS.SELFIE_ENROLLMENT_BLOCKED
  | typeof ERRORS.REQUEST_CREATE_ONBOARDING_LANDING
  | typeof ERRORS.REQUEST_CREATE_ONBOARDING
  | typeof ERRORS.REQUEST_IDENTIFICATION_VERIFICATION
  | typeof ERRORS.REQUEST_ADDRESS_VERIFICATION
  | typeof ERRORS.ACCOUNT_FLOW_NOT_CONFIRMED
  | typeof ERRORS.WRONG_PERSONAL_INFO_COMBINATION
  | typeof ERRORS.ACTIVITY_PYME_FORBIDDEN_RESTRICTED
  | typeof ERRORS.QUERY_RETURN_EVENT;

export type GoogleAnalyticsLabels = "Error_IrASucursal" | string;
